// extracted by mini-css-extract-plugin
export default {"container":"PendingMentors_container__Vgbkt","table":"PendingMentors_table__iU6vd","decline":"PendingMentors_decline__752Ni"};